import { render, staticRenderFns } from "./ActivityList.vue?vue&type=template&id=8493d440&scoped=true"
import script from "./ActivityList.vue?vue&type=script&lang=js"
export * from "./ActivityList.vue?vue&type=script&lang=js"
import style0 from "./ActivityList.vue?vue&type=style&index=0&id=8493d440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8493d440",
  null
  
)

export default component.exports